import React from 'react';
import './StatusNotification.css';

const StatusNotification = ({ message, isVisible }) => {
  return (
    <div className={`status-notification ${isVisible ? 'visible' : ''}`}>
      {message}
    </div>
  );
};

export default StatusNotification; 